import "./NorthWestLondonExpertBuilder.module.css";
import SolidTrustNavigation from "@/reusable_sections/Header";
import MasteringTheLondonSkyline from "./sections/MasteringTheLondonSkyline";
import OurSignatureExtensions from "./sections/OurSignatureExtensions";
import TheLoftConversionSpecialist from "./sections/TheLoftConversionSpecialist";
import RefinedPropertyRenovation from "./sections/RefinedPropertyRenovation";
import StructuralMilestones from "./sections/StructuralMilestones";
import BeginYourTransformation from "./sections/BeginYourTransformation";
import Footer from "@/reusable_sections/Footer";
export default function NorthWestLondonExpertBuilderPage() {
  return <div>
      <SolidTrustNavigation />
      <MasteringTheLondonSkyline />
      <OurSignatureExtensions />
      <TheLoftConversionSpecialist />
      <RefinedPropertyRenovation />
      <StructuralMilestones />
      <BeginYourTransformation />
      <Footer />
    </div>;
}